import React, { useState, useEffect } from 'react'

import dayjs from 'dayjs'

import { useCupons } from '../../context'
import { CourseProps, Profesor, Student, Cupon } from '../../types'
import { getProfileImage } from '../../utilFunctions/profileImage'
import { Spacer } from '../global'
import { SectionSubtitle } from '../texts'

import { DetailsContainer, PhotoContainer, PersonData } from './styles'

const DetailPerson = ({ person }: { person: Profesor | Student }) => {
  const { studentCupons, getStudentCupons } = useCupons()

  const [activeBonos, setActiveBonos] = useState<Cupon[] | null>(null)
  const [activeBono, setActiveBono] = useState<Cupon | null>(null)
  const [activeCourse, setActiveCourse] = useState<Array<CourseProps> | null>(
    null,
  )

  const hasActiveBono = () => {
    const now = dayjs()
    const _activeBonos: Cupon[] = studentCupons?.filter(
      (bono) =>
        dayjs(bono.dueDate).isAfter(now) &&
        bono.attendance < bono.amountOfClasses,
    )
    const _activeBono = _activeBonos.sort((a, b) =>
      dayjs(a.dueDate).diff(dayjs(b.dueDate)),
    )
    setActiveBono(_activeBono[0])
    setActiveBonos(_activeBonos)
  }
  const addWeeksToDate = (dateObj: string, numberOfWeeks: number) => {
    const date = new Date(dateObj)
    date.setDate(date.getDate() + numberOfWeeks * 7)
    return date
  }
  const hasActiveCourse = () => {
    person.courses?.map((item) => {
      if (
        new Date(
          addWeeksToDate(item.inizializationDate, item.duration),
        ).getTime() > new Date().getTime()
      ) {
        activeCourse && setActiveCourse([...activeCourse, item])
      }
    })
  }

  useEffect(() => {
    if (studentCupons) {
      hasActiveBono()
    }
    hasActiveCourse()
  }, [studentCupons])

  useEffect(() => {
    if (person.role === 'student') {
      getStudentCupons(person.uid)
    }
  }, [])

  return (
    <DetailsContainer>
      <PhotoContainer $image={getProfileImage(person.image)} />

      <PersonData>
        <p className="name">
          {person.name} {person.lastname}
        </p>
        <div className="type">
          {person.role === 'student' ? (
            <>
              Alumno: <span>{person.experienceType ?? 'sin información'}</span>
            </>
          ) : (
            <>
              {Array.isArray(person.experienceType) &&
                person.experienceType.map((_exp, i) => {
                  const isLast = i === person.experienceType.length - 1

                  return (
                    <SectionSubtitle
                      key={i}
                      fontSize={12}
                      fontWeight={400}
                      classSub="prof-exp"
                    >
                      <>
                        {_exp}
                        {!isLast && ' -'}
                      </>
                    </SectionSubtitle>
                  )
                })}
            </>
          )}
        </div>
        <div className="bonos">
          <>
            {person.role === 'student' && studentCupons && (
              <>
                <div className="bono">Bonos: {studentCupons?.length} </div>
                {activeBonos && (
                  <>
                    <div className="bono">
                      Bonos activos:{' '}
                      {(person as Student).hasActiveBonus
                        ? activeBonos.length
                        : 0}
                    </div>
                    <div className="bono">
                      Clases: {(person as Student).currentAttendance}/
                      {(person as Student).currentAmountOfClasses}
                    </div>
                  </>
                )}
              </>
            )}
            {person.role === 'student' && person.courses && (
              <div className="bono">
                Curso: {activeCourse?.length} /{' '}
                {person.courses !== undefined && person.courses?.length}
              </div>
            )}

            {person.role === 'professor' &&
              person.activities?.map((item, i) => {
                return (
                  <div key={i} className="bono">
                    {item}
                  </div>
                )
              })}
          </>
        </div>
        <Spacer height={10} />
        {studentCupons &&
        person.role === 'student' &&
        studentCupons?.length > 0 &&
        (person as Student).hasActiveBonus &&
        activeBono ? (
          <p className="type">
            Bono activo hasta el{' '}
            {activeBono?.dueDate &&
              new Date(activeBono.dueDate).toLocaleDateString('es-es', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
          </p>
        ) : (
          <p></p>
        )}
      </PersonData>
    </DetailsContainer>
  )
}

export default DetailPerson
